import React, { memo } from "react";
import { MissionListSearch } from "../MissionListSearch";
import { MissionListTabs } from "../MissionListTabs";
import { MissionListControlsStyled } from "./styles";

export const MissionListControls = memo(() => (
  <MissionListControlsStyled>
    <MissionListTabs />
    <MissionListSearch />
  </MissionListControlsStyled>
));
